import React from 'react'
import Header from './widgets/Header'
import Image from './widgets/Image'

export default function Photos() {
  return (
    <div className='Photos'>
        <Header />
        
        <p className='estimate'>"Crafting outdoor spaces that feel like home."</p>

        <div className='photosCont'>
          <Image />
          <Image />
          <Image />
          <Image />
          <Image />
          <Image />
          <Image />
          <Image />
          <Image />
          <Image />
          <Image />
          <Image />
          <Image />
          <Image />
          <Image />
          <Image />
          <Image />
          <Image />
          <Image />
          <Image />
        </div>
    </div>
  )
}
